import axios from "@/plugins/Axios";

const model = "files-tools";

function remove(id) {
  return axios.delete(`${process.env.VUE_APP_API_URL}/${model}/${id}`);
}

export { remove };
